import { render, staticRenderFns } from "./editSop.vue?vue&type=template&id=b9320430&"
import script from "./editSop.vue?vue&type=script&lang=js&"
export * from "./editSop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports